import React from 'react';
import { Heart } from 'lucide-react';
import { FOOTER_LINKS } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-fnl-dark border-t border-purple-900/40 py-6 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="relative">
            <span className="text-white font-bold text-xl">F</span>
            <Heart className="absolute -top-0.5 -right-2 w-2.5 h-2.5 fill-fnl-pink text-fnl-pink" />
          </div>
          <span className="text-white/80 text-sm font-medium">Flirty</span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {FOOTER_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-purple-200 hover:text-fnl-pink text-xs transition-colors"
            >
              {l.label}
            </a>
          ))}
          <span className="flex items-center gap-1 px-2 py-0.5 bg-fnl-pink rounded text-white text-[10px] font-bold tracking-wider">
            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
            LIVE
          </span>
        </div>

        <div className="text-purple-300/70 text-xs">
          © 2022-2026 OTT B.V.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
